import React from 'react';
import ProductImageThumbnail from './product-image-thumbnail';
import classNames from 'classnames';
import Carousel from '../_common/carousel';
import PreviewImage from './preview-image';
import ThemeAndProductImages from './theme-and-product-images';

class ProductImages extends React.Component {
  constructor(props) {
    super(props);
    const { selectedTheme, product, selectedVariant } = props;
    this.state = {
      index: 0,
      id: product?.id,
      productImages: ThemeAndProductImages({
        selectedTheme,
        product,
        selectedVariant,
      }),
      selectedVariant,
    };
  }

  render() {
    const { product, modal, elegant_corners, scalloped_edges } = this.props;
    const { productImages, index, id } = this.state;

    if (!product || !productImages || productImages.length === 0) {
      return null;
    }

    const slickSettings = {
      arrows: false,
      infinite: true,
      speed: 300,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    const carouselImages = productImages.map((productImage, i) => (
      <PreviewImage
        key={`carousel-image-${i}`}
        asset={productImage}
        index={i}
        isMobile={true}
        {...this.props}
      />
    ));
    return (
      <div className="col-md-12 m-md-0">
        {/* Mobile display */}
        <div className="d-block d-md-none mb-3">
          <Carousel id={id} slickSettings={slickSettings}>
            {carouselImages}
          </Carousel>
        </div>
        {/* Desktop display */}
        <div
          className="d-none d-md-flex thumbnails-wrapper"
          data-test-id="thumbnails-wrapper">
          {this.renderThumbnails()}
          <div
            className={classNames(
              'preview-image col-10 p-0 align-content-center px-2',
              { 'trimmed-edges mx-auto': elegant_corners || scalloped_edges },
              { 'd-flex': modal },
            )}>
            <PreviewImage
              key={productImages[index]?.url || index}
              asset={productImages[index]}
              index={index}
              {...this.props}
            />
            <div className="warning-container"></div>
          </div>
        </div>
      </div>
    );
  }

  renderThumbnails() {
    const {
      rounded_corners,
      elegant_corners,
      scalloped_edges,
      square_edges,
      product,
      selectedTheme,
      modal,
      viewAll,
    } = this.props;
    const { productImages, index } = this.state;

    if (!productImages || productImages.length < 2) return null;

    const attributes = {
      isRounded: rounded_corners,
      isElegant: elegant_corners,
      isScalloped: scalloped_edges,
      isSquare: square_edges,
      isCard: product?.is_card,
    };

    const productTitle = product?.title || '';
    const alt = selectedTheme
      ? `${productTitle} with ${selectedTheme.title} design`
      : productTitle;
    const amountOfThumbnailsToShow = modal ? productImages.length : 6;
    const thumbnails = productImages.slice(0, amountOfThumbnailsToShow);

    const viewAllButton = () => {
      const viewAllCount = productImages.length - thumbnails.length;
      return (
        <button
          className="d-flex flex-wrap flex-column justify-content-center p-0 btn view-all"
          onClick={() => viewAll(true)}>
          <span className="number">+{viewAllCount}</span>
          <span className="view-all">View All</span>
        </button>
      );
    };

    return (
      <ul
        className={classNames(
          'col-2 list-inline thumbnails p-0 d-flex flex-wrap h-100',
          { 'overflow-auto justify-content-center': modal },
          { 'flex-column': !modal },
        )}
        role="radiogroup">
        {thumbnails.map((productImage, i) => {
          const showViewAll =
            i === 5 &&
            productImages.length > amountOfThumbnailsToShow &&
            !modal;
          return (
            <li
              className={classNames('list-inline-item', {
                'show-more position-relative': showViewAll,
              })}
              key={i}>
              <ProductImageThumbnail
                {...productImage}
                {...attributes}
                alt={`Thumbnail for ${alt} ${i + 1}`}
                index={i}
                selected={i === index}
                onClick={this.handleSelected}
                optionAsset={this.customisationOptionAsset()}
                tabIndex={showViewAll ? '-1' : '0'}
              />
              {showViewAll && viewAllButton()}
            </li>
          );
        })}
      </ul>
    );
  }

  customisationOptionAsset = () => {
    const { index } = this.state;
    const { selectedOptions = {}, productOptions = [] } = this.props;
    const [{ id, display_overlay_preview: displayOverlayPreview } = {}] =
      productOptions;
    const { [id]: { asset } = {} } = selectedOptions || {};

    return index === 0 && displayOverlayPreview ? asset : undefined;
  };

  handleSelected = (index) => {
    this.setState((prevState) =>
      index !== prevState.index ? { index } : null,
    );
  };
}

export default ProductImages;
